export enum ADVISING_CATEGORIES {
	ACADEMIC = 1,
	POLICY = 4,
	FINANCIAL = 2,
	SUCCESS_COACHING = 5
}
